import { Component, OnInit, Input,
         Output, EventEmitter, ViewChild } from '@angular/core';

import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { slide } from '../../animations';

@Component({
  selector: 'provider-form-modal',
  templateUrl: './provider-form-modal.component.html',
  styleUrls: ['./provider-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class ProviderFormModalComponent implements OnInit {
  @ViewChild('previewImg') previewImg;

  @Input()  selectedProvider: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  provider = {
    name: "",
    title: "",
    description: ""
  };

  imgSrc = "";
  uploadedFile: File;

  constructor(
    private dbService: DBService,
    private csService: CloudStorageService
  ) { }

  ngOnInit() {
    if (this.selectedProvider) {
      this.provider = this.selectedProvider;
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }


  onRTEKeyup(description) {
    this.provider.description = description;
  }

  submitForm() {

    if (this.selectedProvider) {
      this.dbService.updateProvider(this.selectedProvider.$key,
                                    this.provider,
                                    this.uploadedFile);
    } else {
      this.dbService.addProvider(this.provider,
                                 this.uploadedFile);
    }

    this.onHideModal();
  }

  /* Display upload preview */
  onFileChange(event) {
    let file = event.target.files[0];
    let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.imgSrc = reader.result;
    });

    reader.readAsDataURL(file);
    this.uploadedFile = file;
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/provider-form-modal/provider-form-modal.component.ts